import { cva, VariantProps } from "cva";
import React from "react";

import { SubtleButton } from "./SubtleButton";
import * as styles from "./SubtleButton.module.css";
import { SubtleButtonBulletLink } from "./SubtleButtonBulletLink";
import { SubtleButtonExternalBulletLink } from "./SubtleButtonExternalBulletLink";
import { SubtleButtonExternalLink } from "./SubtleButtonExternalLink";
import { SubtleButtonLink } from "./SubtleButtonLink";

export const variants = cva({
  base: styles.base,
  variants: {
    align: {
      left: styles.left,
      center: styles.center,
      right: styles.right,
    },
    radius: {
      none: styles.radiusNone,
    },
  },
  defaultVariants: {
    align: "center",
  },
});

export type SubtleButtonProps = VariantProps<typeof variants> & {
  disabled?: boolean;
  children?: React.ReactNode;
};

export {
  SubtleButton,
  SubtleButtonBulletLink,
  SubtleButtonExternalBulletLink,
  SubtleButtonExternalLink,
  SubtleButtonLink,
};
